import { TomanPrice } from '@/common/components/atom/toman/toman';
import { withOnlineVisitVat, withOnlineVisitVatText } from '@/common/utils/onlineVisitPriceWithVat';
import React from 'react';

/**
 * The «ویزیت آنلاین: …» price line of a search result card.
 *
 * The search API sends no `price` for most doctors; the line is built from the doctor's online-visit
 * service fee (`consult_services[0].free_price`, rial) on search and home pages. The regular result cards
 * and the promoted «پیشنهاد ویزیت آنلاین پذیرش24» card share this function: the promoted card used to read
 * `price` alone, so it showed no price while the cards below it did (2026-10-16, «درد قفسه سینه» Tehran).
 */
export function onlineVisitPriceLabel(
  item: { price?: unknown; consult_services?: Array<{ free_price?: unknown }> } | undefined,
  includeVat: boolean,
): React.ReactNode {
  const explicitPrice = item?.price;
  if (explicitPrice) {
    return 'ویزیت آنلاین: ' + withOnlineVisitVatText(String(explicitPrice), includeVat);
  }
  // Read only on the fallback path: on the server `window` is undefined, the TypeError reaches the
  // caller's catch (no price line), while an explicit `price` above still renders on the server.
  const href = globalThis.window.location.href;
  const showOnlineVisitPrice =
    /.*paziresh24\.com\/s.*/.test(href) ||
    /^https:\/\/www\.paziresh24\.com\/(?:\?.*)?$/.test(href) ||
    /.*apphome.*/.test(href) ||
    /.*plasmic\.app.*/.test(href);
  const freePriceRaw = item?.consult_services?.[0]?.free_price;
  if (showOnlineVisitPrice && freePriceRaw) {
    const freePriceRial = parseInt(String(freePriceRaw), 10);
    return (
      <>
        ویزیت آنلاین: <TomanPrice>{Math.floor(withOnlineVisitVat(freePriceRial, includeVat) / 10).toLocaleString('fa-IR')}</TomanPrice>
      </>
    );
  }
  return '';
}
